import { Link } from "react-router-dom";
import { LOGO_SRC, NAV_LINKS, PHONE_DISPLAY, PHONE_TEL, EMAIL, EMAIL_MAILTO, WHATSAPP_URL } from "@/constants/site";
import { scrollToTarget } from "@/lib/scroll";

export const Footer = () => (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#070A10]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
            <div>
                <img
                    src={LOGO_SRC}
                    alt="Pare Brise Paris"
                    className="w-20 h-20 rounded-full object-cover ring-2 ring-gold/50"
                />
                <p className="mt-5 text-sm text-gray-400 leading-relaxed max-w-xs">
                    Spécialiste du remplacement et de la réparation de pare-brise, à domicile,
                    partout en France.
                </p>
            </div>

            <div>
                <h4 className="font-display font-semibold text-lg text-gold">Navigation</h4>
                <div className="mt-5 flex flex-col gap-3">
                    {NAV_LINKS.map((link) => (
                        <button
                            key={link.id}
                            data-testid={`footer-nav-${link.id}`}
                            onClick={() => scrollToTarget(`#${link.id}`)}
                            className="text-left text-sm text-gray-400 transition-colors duration-300 hover:text-gold"
                        >
                            {link.label}
                        </button>
                    ))}
                </div>
            </div>

            <div>
                <h4 className="font-display font-semibold text-lg text-gold">Contact</h4>
                <div className="mt-5 flex flex-col gap-3">
                    <a data-testid="footer-phone" href={PHONE_TEL} className="text-sm text-gray-400 transition-colors duration-300 hover:text-gold">
                        {PHONE_DISPLAY}
                    </a>
                    <a data-testid="footer-email" href={EMAIL_MAILTO} className="text-sm text-gray-400 transition-colors duration-300 hover:text-gold">
                        {EMAIL}
                    </a>
                    <a data-testid="footer-whatsapp" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 transition-colors duration-300 hover:text-gold">
                        WhatsApp
                    </a>
                </div>
            </div>

            <div>
                <h4 className="font-display font-semibold text-lg text-gold">Informations</h4>
                <div className="mt-5 flex flex-col gap-3">
                    <Link
                        data-testid="footer-legal"
                        to="/mentions-legales"
                        className="text-sm text-gray-400 transition-colors duration-300 hover:text-gold"
                    >
                        Mentions légales
                    </Link>
                    <Link
                        data-testid="footer-privacy"
                        to="/politique-confidentialite"
                        className="text-sm text-gray-400 transition-colors duration-300 hover:text-gold"
                    >
                        Politique de confidentialité
                    </Link>
                </div>
            </div>
        </div>

        <div className="border-t border-white/5">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 pb-24 md:pb-6">
                <p className="text-xs text-gray-500 text-center">
                    © {new Date().getFullYear()} Pare Brise Paris. Tous droits réservés.
                </p>
            </div>
        </div>
    </footer>
);
